import Loader from "./Loader";
import styles from "../styles/Home.module.css";
import TokenList from "./UserWallet/TokenList";
import React, { useEffect, useState } from "react";
import CroakAuthGlobal from '../services/web3AuthGlobal';
import useLocalStorage from "../utils/useLocalStorage";
import {sortNonNFTTokensList, handleNewNFTToken,
        handleNewNonNFTToken, removeDuplicate } from "../utils/tokenUtils";
import GlipWalletGlobal from '../services/walletService';
import { oldWalletList } from './temp_list';

//force update the
const useForceUpdate = () => {
    const [valuee, setValue] = useState(0); // integer state
    return () => setValue(value => value + valuee + 1); // update the state to force render
}

const Main = () => {
    
    //force update
    const forceUpdate = useForceUpdate();
    
    const handleIncompleteLogin = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        await GlipWalletGlobal.init({
            authName: 'cyan',
            chainId: 1,
            clientIdentifier: urlParams.get('clientIdentifier'),
            isMobileSDK: false,
        });
        await GlipWalletGlobal.handleIncompleteLogin(
            urlParams.get('idToken'),
            urlParams.get('email'),
            urlParams.get('clientIdentifier'));
        setLoggedIn(true);
    }

        
    useEffect(() => {
        (window as any).glipWalletGlobal = GlipWalletGlobal;
        //parse url params
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('incompleteLogin')){
            handleIncompleteLogin();
        }
    }, []);
    
    const [showLoader, setShowLoader] = useState(false);
    // const [localData, setLocalData] =  useState({data: [], nfts: [], tokens: [], activity: [], balance: [0,0], dataSet: false});//useLocalStorage('token-data', {nfts: [], tokens: [], activity: [], balance: '', dataSet: false});
    //const [nonNFTTokensList, setNonNFTTokensList] = useLocalStorage('non-nft-tokens-list', [] as any[]);
    const [nonNFTTokensList, setNonNFTTokensList] = useLocalStorage('non-nft-tokens-list', [] as any[]);
    /* const [nftTokensList, setNFTTokensList] = useLocalStorage('nft-tokens-list', [] as any[]); */
    const [nftTokensList, setNFTTokensList] = useState([] as any[]);
    const [loggedIn, setLoggedIn] = useState(true);
    const [address, setAddress] = useState('');
    const [email, setEmail] = useState('');

    useEffect(()=>{
        const walletId = JSON.parse(localStorage.getItem('gw-wallet-info') || '{}');
        // check if walletid in old walletList
        if(walletId && walletId.address){
            setEmail(walletId.userInfo.email);
        }
    },[])
    

     // useEffect to logout user if user walletid in a list
     useEffect(() => {
         if(window.top !== window.self) {return}
         // get wallet id from local storage
         const walletId = JSON.parse(localStorage.getItem('gw-wallet-info') || '{}');
        // check if walletid in old walletList
        if(walletId && walletId.publicKey && oldWalletList.includes(walletId.publicKey)){
            console.log('setloggedIn false 1')
            setLoggedIn(false);
            setAddress(walletId.publicKey);
            setEmail(walletId.userInfo.email);
        }                        
     }, []);

    useEffect(() => {
        setNFTTokensList([]);
        window.addEventListener('allTokenAdded', (e: any) => {
            console.log('all token added');
            let sortedList = sortNonNFTTokensList(e.detail.tokenList);
            

            setNonNFTTokensList(sortedList);
        });
        window.addEventListener('tokenAdded', (e: any) => {
            const token: any = e.detail;
            if (token.nft) {
                handleNewNFTToken(token, nftTokensList, setNFTTokensList, forceUpdate);
            } else {
                handleNewNonNFTToken(token, nonNFTTokensList, setNonNFTTokensList, sortNonNFTTokensList, forceUpdate);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
        // Dont do anything if current window is not top window
        if(window.top !== window.self) {return}
        if(!GlipWalletGlobal.isConnected()){
            // trigger logout
            // todo: think about this
            console.log('setloggedIn false 2')

            setLoggedIn(false);
            // return;
        }
        const fetchApi = async () => {
            const data: any = await CroakAuthGlobal.fetchNFTsNew();
            //setNonNFTTokensList(data.tokens);
            //setNFTTokensList(data.nfts);
            if(data) {
                // setTokenData(data);
                setShowLoader(false);
                // setLocalData({...tokenData, dataSet: true});
            } else {
                console.log('setloggedIn false 3')
                setLoggedIn(false);
            }            
        }
        fetchApi();
    }, []);
    
    const LoaderComp = () => (
        <div className={styles.centerFlex}>
          <Loader />
        </div>
    );

    // if not logged in user, show button of sending back to android app
    if(!loggedIn){
        return (
            <div className={styles.centerFlex} style={{
                flexDirection:'column'}}>
              <span style={{color: "#ff3333", marginBottom:10}}>
                *You are not logged in, Please login {address}.
              </span>
              <button style={{
                  background: "linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%)", height:70, width:200, border:'none', color:'white', fontSize:17,borderRadius: "20px"
              }}
                      onClick={() => {
                          GlipWalletGlobal.login({
                              loginType:'google',
                              lastLocation:window.location.href});
                      }}>Login</button>
            </div>
        )
    }
    
    return (
        <>
          {!showLoader ? (
              <TokenList
                  nonNFTTokensList={nonNFTTokensList}
                  nftTokensList={nftTokensList}
                  email={email}
                  setLoggedIn={setLoggedIn} />) : <LoaderComp />}
        </>
        
    );
    
};

export default Main;
